"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {
    on,
    addClass,
    findIn,
    setAttribute,
    findAllIn,
    closest,
    trigger
} from "@elements/dom-utils";
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';

let index = 0;
export function init () {
    onFind('.js-filter-group', function (group) {
        let button = findIn('.js-filter-group__btn', group),
            dropdown = findIn('.js-filter-group__dropdown', group),
            selectAll = findIn('.js-filter-group__select-all', group),
            reset = findIn('.js-filter-group__reset', group);

        let autoSubmitOnClose = false;
        let dropdownInstance;

        setButtonCount(findAllIn('input:checked', group).length, button)

        if (matchMedia('(max-width: 767px)').matches) {
            let collapseState = findIn('.js-filter-group__state', dropdown);
            if (!dropdown.getAttribute('id')) {
                setAttribute('id', 'customFilterCollapse-'+ index +'', dropdown);
            }

            let collapse = Collapse.getOrCreateInstance(dropdown, {
                toggle: false
            });

            on('click', () => {
                collapse.toggle();
            }, button);

            if (collapseState) {
                dropdown.addEventListener('hide.bs.collapse', function () {
                    collapseState.value = "false"
                });

                dropdown.addEventListener('shown.bs.collapse', function () {
                    collapseState.value = "true"
                });
            }
        } else {
            setAttribute('data-bs-toggle', 'dropdown', button);
            addClass('dropdown-menu', dropdown);

            dropdownInstance = Dropdown.getOrCreateInstance(button, {
                autoClose: 'outside'
            });

            findAllIn('input', group).map((input) => {
                on('change', () => {
                    autoSubmitOnClose = true;
                }, input)
            });


            //trigger submit event on close
            on('hidden.bs.dropdown', () => {
                if (autoSubmitOnClose) {
                    if (findIn('.js-product-grid__submit-section-btn', group)) {
                        trigger('click', findIn('.js-product-grid__submit-section-btn', group));
                    } else {
                        trigger('submit', closest('form', group));
                    }

                    setButtonCount(findAllIn('input:checked', group).length, button)
                }

                autoSubmitOnClose = false;
            }, button);
        }


        if (selectAll) {
            on('click', () => {
                findAllIn('input[type="checkbox"]', group).map((checkbox) => checkbox.checked = true);

                autoSubmitOnClose = true;
            }, selectAll);
        }

        on('click', () => {
            findAllIn('input[type="checkbox"]', group).map((checkbox) => checkbox.checked = false);

            let rangeSlider = findIn('.js-range-slider', group);
            if (rangeSlider) {
                let values = JSON.parse(rangeSlider.getAttribute('data-range-slider-range'));

                findIn('.js-range-slider__min', rangeSlider).value = values.min;
                findIn('.js-range-slider__max', rangeSlider).value = values.max;
                findIn('.js-range-slider__slider', rangeSlider).noUiSlider.set([findIn('.js-range-slider__min', rangeSlider).value, findIn('.js-range-slider__max', rangeSlider).value])
            }

            if (findIn('.js-product-grid__submit-section-btn', group)) {
                const event = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                });

                findIn('.js-product-grid__submit-section-btn', group).dispatchEvent(event);
            } else {
                trigger('submit', closest('form', group));
            }
        }, reset);

        if (group.getAttribute('data-filter-group-submit-section')) {
            on('change', (evt) => {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }, group)
        }

        //close dropdown on submit click
        if (findIn('[type=submit]', group)) {
            on('click', () => {
                autoSubmitOnClose = false;

                if (dropdownInstance) {
                    dropdownInstance.hide();
                }

                setButtonCount(findAllIn('input:checked', group).length, button)

            }, findIn('[type=submit]', group))
        }

        index += 1;
    });
}

function setButtonCount (count, button) {
    if (count > 0) {
        findIn('.js-filter-group__btn-count', button).innerHTML = '(' + count + ')';
        // addClass('is-active', button);
    } else {
        findIn('.js-filter-group__btn-count', button).innerHTML = '';
        // removeClass('is-active', button);
    }
}
